import { render } from "./WalletBalance.vue?vue&type=template&id=26b063bc"
import script from "./WalletBalance.vue?vue&type=script&lang=js"
export * from "./WalletBalance.vue?vue&type=script&lang=js"

import "./WalletBalance.vue?vue&type=style&index=0&id=26b063bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__